import { render, staticRenderFns } from "./SaturdayRoster.vue?vue&type=template&id=b4fd27ec&"
import script from "./SaturdayRoster.vue?vue&type=script&lang=js&"
export * from "./SaturdayRoster.vue?vue&type=script&lang=js&"
import style0 from "./SaturdayRoster.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports